import { render } from "./VehicleBpmEmptyCard.vue?vue&type=template&id=559606cb&scoped=true"
import script from "./VehicleBpmEmptyCard.vue?vue&type=script&lang=js"
export * from "./VehicleBpmEmptyCard.vue?vue&type=script&lang=js"

import "./VehicleBpmEmptyCard.vue?vue&type=style&index=0&id=559606cb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559606cb"]])

export default __exports__